export default {
  downtimeUrl: "https://www.kodland.org/es",
  newDesign: true,
  title: "¿Sabes cómo ayudar a tu hijo con el estrés? | Kodland",
  parameters: {
    landing_id: "EsQuStPaid",
    segment: 14,
  },
  startPage: {
    title:
      "¡Realiza el test de 2 minutos y descubre cómo apoyar a tu hijo frente al estrés escolar y emocional!",
    subtitle:
      "✔️ Elaborado por expertos en crianza y bienestar<br>❤️ Completamente gratuito<br>🎁 Recomendaciones prácticas al finalizar el test<br>👪 Más de 200 mil padres confían en nosotros",
    image: {
      url: "/welcome/es_content_stress_paid_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/es_content_stress_paid_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " ¡Empieza ahora! 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Tu hijo se estresa con la escuela. ¿Qué sueles hacer tú en esos momentos?",
      answers: [
        "Le quito pantallas o lo mando a estudiar 🤷",
        "Me frustro, no sé bien qué hacer 🫤",
        "Lo escucho y lo apoyo 🤗",
      ],
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_stress_paid_1.png",
      title: "Muchos niños se sienten abrumados por las tareas y exámenes.",
      subtitle:
        "Lo importante es cómo respondemos como padres. Aquí te mostramos lo que suele ayudar... y lo que no tanto.",
      button: "Lo tengo claro, sigamos ✅",
    },
    3: {
      question:
        "Tu hijo tiene conflictos en la escuela, no tiene amigos o le cuesta llevarse con otros. ¿Qué haces?",
      answers: [
        "No hago nada, son cosas de niños 🙄",
        "Voy al colegio a reclamar 😡",
        "Hablo con los maestros o busco apoyo 😔",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_stress_paid_4.png",
      subtitle:
        "Por qué importa? Las relaciones sociales son clave para su bienestar. A veces el problema viene de dentro (ansiedad, timidez, dificultad para manejar el enojo). Otras veces, del entorno.",
      button: "Todo claro 👌",
    },
    5: {
      question:
        "¿Una mudanza, nueva escuela o nuevos amigos? ¡Suena emocionante para un niño! ¿Tú qué opinas?",
      answers: ["Sí, está genial 😉", "No estoy tan seguro/a 😕"],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_stress_paid_6.png",
      subtitle:
        "¿Sabías esto? La psicología distingue entre eustrés y distrés. Incluso los cambios positivos pueden causar distrés si el niño no está preparado o no se siente apoyado. ",
      button: "Interesante 👀",
    },
    7: {
      question:
        "Los cambios también afectan el cuerpo y la identidad. Los niños crecen rápido. ¿Vale la pena hablar de eso?",
      answers: [
        "Supongo que sí, pero no sé cómo 😯",
        "Sí, los padres deben explicarlo todo 😌",
        "No, sería incómodo para todos 😐",
      ],
    },
    8: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_stress_paid_8.png",
      title:
        "¿Sabías que muchos niños sienten estrés en el cuerpo, no solo en la mente?",
      subtitle:
        "Cuando no entienden lo que les pasa, pueden asustarse o sentirse inseguros.<br>🧘‍♀️ Aquí te compartimos una técnica muy sencilla que recomiendan psicólogos para reducir el estrés y ayudarles a relajarse.",
      button: "¡Quiero aprenderla!",
    },
    9: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_stress_paid_9.png",
      subtitle:
        "Ayuda a tu hijo a relajarse y reconectar con su cuerpo. Guárdala para cuando más la necesite.",
      button: "Siguiente paso ➡️",
    },
    10: {
      question: "¿Cómo reaccionarías si tu hijo se enferma?",
      answers: [
        "El que necesita apoyo soy yo 😰",
        "¿Y eso por qué necesita apoyo? 🙄",
        "Lo rodearía de cariño y atención 🤗",
      ],
    },
    11: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_stress_paid_11.png",
      subtitle:
        "¿Por qué importa? Cuando se enferman, los niños no solo sienten malestar físico — también pueden ponerse tristes por faltar a clases o no ver a sus amigos. Y sí, se sienten igual de mal que tú con una buena gripe.<br><br>Evita presionarlos o hacerlos sentir culpables. Además de cuidarlos físicamente, también necesitan contención emocional.",
      button: "¡Perfecto!",
    },
    12: {
      question: "¿Qué le dirías a tu hijo cuando algo no le sale bien?",
      answers: [
        "Esfuérzate más y saldrá mejor 💪",
        "No es para tanto, olvídalo 😇",
        "Estamos decepcionados 😤",
        "¿Cómo te ayudo? 😔",
      ],
    },
    13: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_stress_paid_13.png",
      subtitle:
        "¿Por qué importa? Los fracasos pueden dejar marcas emocionales si no se procesan bien. Ayúdalo a entender que equivocarse no define quién es.",
      button: "Recibe algo útil para tu hijo 🎁",
    },
    14: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      button: "",
    },
    15: {
      question:
        "¿Tienes una computadora de escritorio o portátil en la que tu hijo puede jugar o estudiar?",
      answers: [
        "Si ✅",
        {
          answer: "No ☹️",
          stopAnswer: true,
        },
      ],
    },
    16: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q15.png",
      title: "Tenemos un regalo para ti 🎁",
      subtitle:
        "Este test fue creado por expertos de Kodland, escuela online donde los niños aprenden tecnología en un ambiente positivo y sin presión. Te invitamos a una clase de prueba gratuita: 100% online, en vivo y con profesor.<br>Tu hijo aprenderá programación mientras gana confianza, mejora la concentración y se divierte.<br>Regístrate y elige tu horario. ¡Nos vemos en clase! 🚀",
      button: "Reservar mi clase gratuita 🔥",
    },
    17: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Elige una fecha ➡️",
    },
    18: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    19: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    20: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    21: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
